import type { RefOrGetter } from "ls/common/types";
import type { IconData } from "@/generated/models";
import { computed, toValue } from "vue";
import { BannerType } from "@/generated/models";

export function useIconData(data: RefOrGetter<IconData | undefined>) {
  const hasBanner = computed(() => {
    const type = toValue(data)?.BannerType;
    return type != null;
  });

  const hasIcon = computed(() => {
    const type = toValue(data)?.Type;
    return type != null;
  });

  const isEmpty = computed(() => {
    return !hasBanner.value && !hasIcon.value;
  });

  const isBannerImage = computed(() => {
    const type = toValue(data)?.BannerType;
    return type === BannerType.Upload && toValue(data)?.BannerImageHash;
  });

  return {
    hasIcon,
    hasBanner,
    isEmpty,
    isBannerImage,
  };
}
